import { atom } from "recoil";

const clickedProfileAtom = atom({
  key: "clickedProfileState",
  default: false,
});

export default clickedProfileAtom;
